module.exports = __webpack_public_path__ + "img/img-4.ef36d1a0.png";